import * as components from './components'
import { services } from './services'

export * from './types'

export const notifications: {
  meta: {
    name: 'notification'
  }
  components: typeof components
  layers: {
    services: typeof services
  }
} = {
  meta: {
    name: 'notification',
  },
  components,
  layers: {
    services,
  },
}
